export default __webpack_public_path__ + "static/media/politician.9cfd9f1c.png";